import { Controller } from "@hotwired/stimulus"

// 역할 선택에 따라 프로필 섹션 표시/숨김
export default class extends Controller {
  static targets = ["roleRadio", "profileSection", "hourlyRateSection", "settlementRateSection", "partnerOnlyField", "profileImageSection", "affiliateDeductionSection"]

  connect() {
    this.updateVisibility()
  }

  roleChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selectedRole = this.getSelectedRole()
    const needsProfile = selectedRole === "partner" || selectedRole === "affiliate"
    const isPartner = selectedRole === "partner"

    // 프로필 섹션 표시/숨김
    if (this.hasProfileSectionTarget) {
      if (needsProfile) {
        this.profileSectionTarget.classList.remove("hidden")
      } else {
        this.profileSectionTarget.classList.add("hidden")
      }
    }

    // 시급 필드는 파트너만 표시
    if (this.hasHourlyRateSectionTarget) {
      if (isPartner) {
        this.hourlyRateSectionTarget.classList.remove("hidden")
      } else {
        this.hourlyRateSectionTarget.classList.add("hidden")
      }
    }

    // 정산 비율 필드는 파트너만 표시 (협력사는 원금 그대로 입금)
    if (this.hasSettlementRateSectionTarget) {
      if (isPartner) {
        this.settlementRateSectionTarget.classList.remove("hidden")
      } else {
        this.settlementRateSectionTarget.classList.add("hidden")
      }
    }

    // 가능 인원수 필드는 파트너만 표시
    if (this.hasPartnerOnlyFieldTarget) {
      if (isPartner) {
        this.partnerOnlyFieldTarget.classList.remove("hidden")
      } else {
        this.partnerOnlyFieldTarget.classList.add("hidden")
      }
    }

    // 프로필 이미지는 파트너만 표시
    if (this.hasProfileImageSectionTarget) {
      if (isPartner) {
        this.profileImageSectionTarget.classList.remove("hidden")
      } else {
        this.profileImageSectionTarget.classList.add("hidden")
      }
    }

    // 공제 옵션은 협력사만 표시
    const isAffiliate = selectedRole === "affiliate"
    if (this.hasAffiliateDeductionSectionTarget) {
      if (isAffiliate) {
        this.affiliateDeductionSectionTarget.classList.remove("hidden")
      } else {
        this.affiliateDeductionSectionTarget.classList.add("hidden")
      }
    }
  }

  getSelectedRole() {
    // 라디오 버튼에서 찾기 (신규 사용자)
    const checked = this.roleRadioTargets.find(radio => radio.checked)
    if (checked) return checked.value

    // hidden_field에서 찾기 (기존 사용자)
    const hiddenField = this.element.querySelector('input[name="user[role]"][type="hidden"]')
    if (hiddenField) return hiddenField.value

    return null
  }
}
